<template>
  <div class="text-center">
    <div class="flex justify-center list-none mb-base">
      <button
        type="button"
        @click.prevent="handlePaging(previousLink)"
        class="no-underline border-solid rounded-full cursor-pointer p-0 px-xs ml-0 text-primary h-lg min-w-paginationButton mx-xs border-primary border-1 bg-whiteOverride hover:bg-primary hover:text-whiteOverride disabled:cursor-not-allowed disabled:bg-border disabled:border-border disabled:text-signableSecondary3"
        :disabled="!previousLink"
        data-test="previous-button"
        :data-ec="`${pageDataEc}_paginator`"
        data-et="previous_button"
      >
        <ChevronLeftIcon class="text-14" />
      </button>

      <ul class="pl-0 my-0">
        <li
          v-for="(link, index) in numberedLinks"
          class="inline-block mb-xs"
          :key="index"
          :class="{
            'first-ellipsis': shouldShowFirstEllipsis(),
            'last-ellipsis': shouldShowLastEllipsis()
          }"
        >
          <button
            type="button"
            @click.prevent="handlePaging(link.url, link.active)"
            class="font-bold no-underline border-solid rounded-full p-0 px-xs mx-3 cursor-pointer text-16 font-body text-primary h-lg min-w-paginationButton mx-xs border-primary border-1 bg-whiteOverride hover:bg-primary hover:text-whiteOverride disabled:cursor-not-allowed disabled:min-w-0 disabled:bg-transparent disabled:border-0 disabled:text-signableSecondary3 disabled:mx-0"
            :class="{ active: link.active, 'hidden sm:block': hideOnExtraSmallViewport(link, index)}"
            :data-test="`page-${index + 1}`"
            :disabled="link.url === null"
            :data-ec="`${pageDataEc}_paginator`"
            data-et="page_button"
          >
            {{ link.label }}
          </button>
        </li>
      </ul>

      <button
        type="button"
        @click.prevent="handlePaging(nextLink)"
        class="no-underline border-solid rounded-full cursor-pointer p-0 px-xs mr-0 text-primary h-lg min-w-paginationButton mx-xs border-primary border-1 bg-whiteOverride hover:bg-primary hover:text-whiteOverride disabled:cursor-not-allowed disabled:bg-border disabled:border-border disabled:text-signableSecondary3"
        :disabled="!nextLink"
        data-test="next-button"
        :data-ec="`${pageDataEc}_paginator`"
        data-et="next_button"
      >
        <ChevronRightIcon class="text-14" />
      </button>
    </div>

    <p
      v-if="meta.from && meta.to"
      class="font-bold text-14"
    >
      {{
        $t('pagination.total', {
          from: meta.from,
          to: meta.to,
          total: meta.total,
          resource: resource,
        })
      }}
    </p>
  </div>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon } from '@/components/icons/fontIcons';

export default {
  name: 'NumberedPaginator',
  props: {
    meta: {
      type: Object,
      required: true,
    },
    resource: {
      type: String,
      required: true,
    },
    pageDataEc: {
      type: String,
      required: true,
    },
  },
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
  },
  computed: {
    previousLink() {
      return this.meta.links.length > 0 ? this.meta.links[0].url : null;
    },
    nextLink() {
      return this.meta.links.length > 0
        ? this.meta.links[this.meta.links.length - 1].url
        : null;
    },
    numberedLinks() {
      return this.meta.links.slice(1, -1);
    },
  },
  methods: {
    handlePaging(url, active = false) {
      if (url && !active) {
        this.$emit('page', url);
      }
    },
    shouldShowFirstEllipsis() {
      if (this.numberedLinks.length <= 5) {
        return false;
      }

      const activeIndex = this.numberedLinks.findIndex(l => l.active);

      return activeIndex >= 3;
    },
    shouldShowLastEllipsis() {
      if (this.numberedLinks.length <= 5) {
        return false;
      }

      const activeIndex = this.numberedLinks.findIndex(l => l.active);

      return activeIndex <= this.numberedLinks.length - 4;
    },
    hideOnExtraSmallViewport(link, index) {
      // If there are 5 or less links
      if (this.numberedLinks.length <= 5) {
        return false;
      }

      // Get the active index
      const activeIndex = this.numberedLinks.findIndex(l => l.active);

      // Active page || first or last index
      if (activeIndex === index || index === 0 || index === this.numberedLinks.length - 1) {
        return false;
      }

      // First three pages
      if (activeIndex <= 1 && index <= 3) {
        return false;
      }

      // Last three pages
      if (activeIndex >= this.numberedLinks.length - 2 && index >= this.numberedLinks.length - 4) {
        return false;
      }

      // One button either side of the active page
      if (Math.abs(activeIndex - index) <= 1) {
        return false;
      }

      // None of the above then don't display
      return true;
    },
  },
};
</script>

<style scoped>
.active {
  @apply text-whiteOverride bg-primary cursor-default;
}
.first-ellipsis:first-child:after, .last-ellipsis:last-child:before{
  content: '...';
  @apply cursor-not-allowed min-w-0 bg-transparent border-0 text-signableSecondary3 mx-3 sm:hidden
}
</style>
